import PropTypes from 'prop-types'
import React from 'react'
import _ from 'lodash'
import classnames from 'classnames'
import CountdownTimer from '../../CountdownTimer'
import keyUpHandler from '../../../utils/keyUpHandler'
import { bannerPropType } from '..'
import './styles.css'

function BannerSlide({
  asset,
  countdownDate,
  link,
  ctaUrl,
  ctaLabel,
  title,
  description,
  hasGradient,
  video,
  videoThumbnail = null,
  displayVideo = () => {}
}) {

  const withTimer = !_.isNull(countdownDate)

  // A single overlay <a> below is the one link per slide; the slide container
  // itself is presentational. Keeping it non-interactive avoids nesting a link
  // (and the CTA) inside an outer button.
  return (
    <div
      className={classnames('banner-slide', { linkable: !_.isNull(link) })}
      style={{ backgroundImage: `url(${asset.original})` }}
    >
      {_.isNull(ctaUrl) && (
        <div className="overlay gradient">
          {!_.isNull(link) && (
            <a aria-label={title} href={link}>
              {' '}
            </a>
          )}
        </div>
      )}
      {!_.isNull(ctaUrl) && (
        <a
          aria-label={title}
          className={classnames('overlay', { gradient: hasGradient })}
          href={ctaUrl}
        >
          {' '}
        </a>
      )}
      <div className="wrapper">
        <div className="banner-info">
          <div className={classnames('title', { expand: !withTimer })}>
            {title}
          </div>
          <div className={classnames('description', { expand: !withTimer })}>
            <p>{description}</p>
          </div>
          {withTimer && (
            <div className="countdown">
              <CountdownTimer
                targetDate={countdownDate}
                startDelay={2000}
                interval={1000}
                leadingZero
              />
            </div>
          )}
          {!_.isNull(ctaLabel) && !_.isNull(ctaUrl) && (
            <div className="cta">
              {/* Visual button only — the overlay <a> above is the actual link,
                  so the whole slide (including here) navigates via one link. */}
              <span className="btn -thin -orange">{ctaLabel}</span>
            </div>
          )}
        </div>
        {video && videoThumbnail && (
          <div
            aria-labelledby="video-cta-label"
            className="video-banner"
            onClick={() => displayVideo(video)}
            onKeyUp={(event) => keyUpHandler(event, displayVideo, null, null, video)}
            tabIndex={0}
            role="button"
          >
            <div
              className="video-banner__thumb"
              style={{ backgroundImage: `url(${videoThumbnail})` }}
            >
              <div className="video-cta">
                <i className="icon-play video-cta__icon" />
                <span className="video-cta__text" id="video-cta-label">
                  Learn more
                </span>
              </div>
            </div>
          </div>
        )}
      </div>
    </div>
  )
}

BannerSlide.propTypes = {
  ...bannerPropType,
  displayVideo: PropTypes.func,
  videoThumbnail: PropTypes.string
}

export default BannerSlide
